import { render, staticRenderFns } from "./SwiftaTransactionDetail.vue?vue&type=template&id=2b761439&scoped=true"
import script from "./SwiftaTransactionDetail.vue?vue&type=script&lang=js"
export * from "./SwiftaTransactionDetail.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b761439",
  null
  
)

export default component.exports